export default __webpack_public_path__ + "static/media/LoginPageImage.87373db6.png";